import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettings } from '../common/app.settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class BaseService {

    constructor(public http: HttpClient){
	}
public clearCache(){}
_getSecuredHeaders()
{
        let currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        let token = '';
        if(currentUser )
        {
        token = currentUser.vid;
        }
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Accept', 'application/json')
            .set('vid', token);
        return headers;
}
_getHeaders()
{
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return headers;
}
    _checkValidSession()
    {
       let currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        if(currentUser)
        {
            let expiry = currentUser.expiry;
            var now = new Date(); 
            var currentTime = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),  now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
            var time = Date.parse(expiry)
            var expiryTime = new Date(time);
            return currentTime < expiryTime
        }
        else
            return false
    }
    saveEntity(vvModel: any,entityType): Observable<Object> {
        var params = JSON.stringify(vvModel);

        var endpoint = AppSettings.VV_CLIENT_EDIT_EP;
        if(entityType=='tenant')
            endpoint=AppSettings.VV_TENANT_EDIT_EP;
        else if(entityType=='environment')
            endpoint=AppSettings.VV_ENVIRONMENT_EDIT_EP;
        return this.http
            .post(`${AppSettings.API_ENDPOINT}${endpoint}`, params)
            .pipe(map((response: Response) => {
                return response;
            }));
    }
    
}